<template>
  <div id="app">
    <nav-bar></nav-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import nav from './components/nav.vue';

export default {

  data(){
    return{

    }
  },

  components: {
    'nav-bar': nav
  }
}
</script>

<style>
body html{
  background-color: #f4f4f4;
  width: 100%;
  height: 100%;
}
</style>
